module.exports = __webpack_public_path__ + "img/spyder-show.0dc15929.png";